// export const Chat_API_URL =
//   "https://dinedealschatflowbackend.smartyuppies.com/";

// export const Chat_API_URL = "https://chatflow.dinedeal.in/";

export const Chat_API_URL = "https://crm-marketspace-chatapi.harxatech.com/";
